import React from "react";
import "../../assets/css/home-page/testimonial.css";

export default function Testimonials() {
  const engineeringReviews = [
    {
      quote:
        "Our highway expansion project required strict NP4 class concrete pipes on a demanding schedule. The dimensional accuracy and structural integrity of the units delivered were exceptional.",
      leader: "Ir. Anand Shah",
      wing: "Infrastructure Procurement Lead",
      enterprise: "National Highway Construction Consortium",
    },
    {
      quote:
        "The pipe caging configurations were adapted precisely to our structural drawings. The technical documentation and load testing certificates provided met all oversight requirements.",
      leader: "Marcus Vance",
      wing: "Chief Technical Representative",
      enterprise: "Metropolitan Sewerage & Clean Water Board",
    },
  ];

  return (
    <section id="testimonials" className="testimonials-blackout-section">
      <div className="container-fluid">
        <div className="testimonials-head animate-on-scroll">
          <h2>Verified Infrastructure Partners</h2>
          <p>
            See feedback from leading engineers and procurement teams who rely
            on our concrete pipes for major infrastructure projects.
          </p>
        </div>

        <div className="testimonials-flex-pool">
          {engineeringReviews.map((rev, idx) => (
            <blockquote
              key={idx}
              className="corporate-testimonial-block animate-on-scroll"
            >
              <p className="actual-quote-text">"{rev.quote}"</p>
              <footer className="corporate-cite-footer">
                <span className="client-name">{rev.leader}</span>
                <span className="client-role">{rev.wing}</span>
                <span className="client-firm">{rev.enterprise}</span>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
